export enum MeetingHubTabs {
  All = 0,
  Shared = 1
}
